import { Radio, RadioGroup, useRadioState } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { ItemRestriction as Restriction, Scope } from 'typings'
import { useFormStateContext } from '../../../providers'
import { ScopeRestrictionsList } from './RestrictionsList'
import { EMPTY_SCOPE } from './constants'

function getInitialState(scope: Scope) {
  const hasScopeRestrictions = Object.values(scope).some(
    (restriction: Restriction) => restriction.items.length > 0
  )
  return hasScopeRestrictions ? 'specific-products' : 'all-products'
}

interface Props {
  name: string
}

export function ScopeRestriction(props: Props) {
  const { name } = props
  const { formatMessage } = useIntl()
  const { form, readOnly } = useFormStateContext()
  const scope: Scope = useWatch({ form, name })

  const state = useRadioState({ defaultValue: getInitialState(scope) })

  const scopeEditorEnabled = state.value === 'specific-products'

  function resetScope() {
    form.resetField(name, { defaultValue: { ...EMPTY_SCOPE } })

    state.setValue('all-products')
  }

  return (
    <>
      <RadioGroup state={state} label="">
        <Radio
          value="all-products"
          label={formatMessage({
            id: 'admin/promotions.form.scope.all-products',
          })}
          onChange={resetScope}
          disabled={readOnly}
        />
        <Radio
          value="specific-products"
          label={formatMessage({
            id: 'admin/promotions.form.scope.specific-products',
          })}
          disabled={readOnly}
        />
      </RadioGroup>

      {scopeEditorEnabled ? (
        <ScopeRestrictionsList name={name} resetScope={resetScope} />
      ) : null}
    </>
  )
}
